import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { GHOST_ASSET_ID, GHOST_ENERGY_STAT_ENTRIES, GHOST_STATUS_HISTORY_ENTRIES } from "../../shared/ghostData";
import { getMethanolStatisticsData } from "../api/methanol-statistics.service";
const selectWithGhostEnergy = (data) => {
    if (data?.statDetails?.length)
        return data;
    return { ...data, statDetails: GHOST_ENERGY_STAT_ENTRIES, statType: "energy" };
};
export const groupStatusHistory = (entries) => {
    let charging = 0;
    let idle = 0;
    let discharging = 0;
    let notReporting = 0;
    entries.forEach(({ assetStatus, duration }) => {
        const status = assetStatus.toLowerCase().replace(/\s+/g, "");
        if (status === "charging" || status === "ac_charging" || status === "dc_charging") {
            charging += duration;
        }
        else if (status === "idle") {
            idle += duration;
        }
        else if (status === "discharging" || status === "working") {
            discharging += duration;
        }
        else {
            notReporting += duration;
        }
    });
    return [
        { assetStatus: "charging", duration: charging, unitOfMeasure: "hours" },
        { assetStatus: "idle", duration: idle, unitOfMeasure: "hours" },
        { assetStatus: "discharging", duration: discharging, unitOfMeasure: "hours" },
        { assetStatus: "notreporting", duration: notReporting, unitOfMeasure: "hours" }
    ].filter((e) => e.duration > 0);
};
const selectWithGhostRunningHours = (data) => {
    if (data?.statusHistory?.length)
        return data;
    return { ...data, statType: "runningHours", statusHistory: groupStatusHistory(GHOST_STATUS_HISTORY_ENTRIES) };
};
export const useMethanolStatisticsQuery = ({ assetId, enabled = true, fromDate, projectId, showGhostAssetPhaseOne = false, statType, toDate }) => {
    const requestBody = useMemo(() => ({
        filters: [
            {
                propertyName: "timestamp",
                range: {
                    left: fromDate,
                    right: toDate
                },
                type: "timeRange"
            },
            {
                isCaseSensitive: true,
                propertyName: "assetId",
                type: "stringEquals",
                values: [assetId]
            },
            {
                isCaseSensitive: true,
                propertyName: "projectId",
                type: "stringEquals",
                values: [projectId]
            },
            {
                isCaseSensitive: true,
                propertyName: "aggregationType",
                type: "stringEquals",
                values: ["daily"]
            }
        ]
    }), [fromDate, toDate, projectId, assetId]);
    const isGhostMachineWithData = showGhostAssetPhaseOne && assetId === GHOST_ASSET_ID;
    return useQuery({
        enabled: enabled && !!assetId && !!projectId && !!fromDate && !!toDate,
        queryFn: () => getMethanolStatisticsData(statType, requestBody),
        queryKey: ["methanolStatistics", statType, projectId, assetId, fromDate, toDate],
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 5 * 60 * 1000,
        ...(isGhostMachineWithData && statType === "energy" ? { select: selectWithGhostEnergy } : {}),
        ...(isGhostMachineWithData && statType === "runningHours" ? { select: selectWithGhostRunningHours } : {})
    });
};
